"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locationDMS = void 0;
var formatcoords_1 = __importDefault(require("formatcoords"));
var locationDMS = function (entity) {
  return entity.latitude && entity.longitude && (0, formatcoords_1.default)(entity.latitude, entity.longitude).format('f', {
    decimalPlaces: 4
  });
};
exports.locationDMS = locationDMS;